import { AppBlock } from '@boost/widget-integration-tae/lib';
import { ModuleRefImpl } from 'framework/core';
import { Singleton } from 'framework/di';

import { CartDrawerRecommendationController } from './controller';

@Singleton()
export class CartDrawerRecommendationLifecycle {
  protected currentController: CartDrawerRecommendationController | null = null;

  constructor(protected moduleRef: ModuleRefImpl) {}

  get controller(): CartDrawerRecommendationController | null {
    return this.currentController;
  }

  async initialize(block: AppBlock): Promise<void> {
    if (!(block.document instanceof HTMLElement) || this.currentController) {
      return;
    }

    this.currentController = await this.moduleRef.resolve(CartDrawerRecommendationController);
  }

  destroy(): void {
    this.currentController?.destroy();
    this.currentController = null;
  }
}
